namespace $ {
	export class $aspirity_account_new extends $mol_page {
		
		/**
		 * ```tree
		 * title @ \Creating an invoice
		 * ```
		 */
		title() {
			return this.$.$mol_locale.text( '$aspirity_account_new_title' )
		}
		
		/**
		 * ```tree
		 * body / <= List
		 * ```
		 */
		body() {
			return [
				this.List()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Row!id $mol_form form_fields /
		 * 	<= People!id
		 * 	<= Position!id
		 * 	<= Rate!id
		 * 	<= Time!id
		 * 	<= Price!id
		 * ```
		 */
		@ $mol_mem_key
		Row(id: any) {
			const obj = new this.$.$mol_form()
			
			obj.form_fields = () => [
				this.People(id),
				this.Position(id),
				this.Rate(id),
				this.Time(id),
				this.Price(id)
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * subject_bid \
		 * ```
		 */
		subject_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * subject?val \
		 * ```
		 */
		@ $mol_mem
		subject(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * Subject_control $mol_string value?val <=> subject?val
		 * ```
		 */
		@ $mol_mem
		Subject_control() {
			const obj = new this.$.$mol_string()
			
			obj.value = (val?: any) => this.subject(val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Subject $mol_form_field
		 * 	name @ \Subject
		 * 	bid <= subject_bid
		 * 	control <= Subject_control
		 * ```
		 */
		@ $mol_mem
		Subject() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Subject_name' )
			obj.bid = () => this.subject_bid()
			obj.control = () => this.Subject_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * number_bid \
		 * ```
		 */
		number_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * number?val \
		 * ```
		 */
		@ $mol_mem
		number(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * Number_control $mol_string value?val <=> number?val
		 * ```
		 */
		@ $mol_mem
		Number_control() {
			const obj = new this.$.$mol_string()
			
			obj.value = (val?: any) => this.number(val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Number $mol_form_field
		 * 	name @ \Invoice number
		 * 	bid <= number_bid
		 * 	control <= Number_control
		 * ```
		 */
		@ $mol_mem
		Number() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Number_name' )
			obj.bid = () => this.number_bid()
			obj.control = () => this.Number_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * status_bid \
		 * ```
		 */
		status_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * status?val \
		 * ```
		 */
		@ $mol_mem
		status(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * status_dict *
		 * ```
		 */
		status_dict() {
			return {
			}
		}
		
		/**
		 * ```tree
		 * Status_control $mol_select
		 * 	value?val <=> status?val
		 * 	dictionary <= status_dict
		 * ```
		 */
		@ $mol_mem
		Status_control() {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.status(val)
			obj.dictionary = () => this.status_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Status $mol_form_field
		 * 	name @ \Status
		 * 	bid <= status_bid
		 * 	control <= Status_control
		 * ```
		 */
		@ $mol_mem
		Status() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Status_name' )
			obj.bid = () => this.status_bid()
			obj.control = () => this.Status_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * contractor_bid \
		 * ```
		 */
		contractor_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * contractor?val \
		 * ```
		 */
		@ $mol_mem
		contractor(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * contractor_dict *
		 * ```
		 */
		contractor_dict() {
			return {
			}
		}
		
		/**
		 * ```tree
		 * Contractor_select $mol_select
		 * 	value?val <=> contractor?val
		 * 	dictionary <= contractor_dict
		 * ```
		 */
		@ $mol_mem
		Contractor_select() {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.contractor(val)
			obj.dictionary = () => this.contractor_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contractor_add_icon $mol_icon_plus
		 * ```
		 */
		@ $mol_mem
		Contractor_add_icon() {
			const obj = new this.$.$mol_icon_plus()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contractor_add $mol_link
		 * 	arg * contractor \
		 * 	sub / <= Contractor_add_icon
		 * ```
		 */
		@ $mol_mem
		Contractor_add() {
			const obj = new this.$.$mol_link()
			
			obj.arg = () => ({
				contractor: ""
			})
			obj.sub = () => [
				this.Contractor_add_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contractor_control $mol_bar sub /
		 * 	<= Contractor_select
		 * 	<= Contractor_add
		 * ```
		 */
		@ $mol_mem
		Contractor_control() {
			const obj = new this.$.$mol_bar()
			
			obj.sub = () => [
				this.Contractor_select(),
				this.Contractor_add()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contractor $mol_form_field
		 * 	name @ \Contractor
		 * 	bid <= contractor_bid
		 * 	control <= Contractor_control
		 * ```
		 */
		@ $mol_mem
		Contractor() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Contractor_name' )
			obj.bid = () => this.contractor_bid()
			obj.control = () => this.Contractor_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * contact_bid \
		 * ```
		 */
		contact_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * contact?val \
		 * ```
		 */
		@ $mol_mem
		contact(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * contact_dict *
		 * ```
		 */
		contact_dict() {
			return {
			}
		}
		
		/**
		 * ```tree
		 * Contact_select $mol_select
		 * 	value?val <=> contact?val
		 * 	dictionary <= contact_dict
		 * ```
		 */
		@ $mol_mem
		Contact_select() {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.contact(val)
			obj.dictionary = () => this.contact_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contact_add_icon $mol_icon_plus
		 * ```
		 */
		@ $mol_mem
		Contact_add_icon() {
			const obj = new this.$.$mol_icon_plus()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contact_add $mol_link
		 * 	arg * contact \
		 * 	sub / <= Contact_add_icon
		 * ```
		 */
		@ $mol_mem
		Contact_add() {
			const obj = new this.$.$mol_link()
			
			obj.arg = () => ({
				contact: ""
			})
			obj.sub = () => [
				this.Contact_add_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contact_control $mol_bar sub /
		 * 	<= Contact_select
		 * 	<= Contact_add
		 * ```
		 */
		@ $mol_mem
		Contact_control() {
			const obj = new this.$.$mol_bar()
			
			obj.sub = () => [
				this.Contact_select(),
				this.Contact_add()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contact $mol_form_field
		 * 	name @ \Contact person
		 * 	bid <= contact_bid
		 * 	control <= Contact_control
		 * ```
		 */
		@ $mol_mem
		Contact() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Contact_name' )
			obj.bid = () => this.contact_bid()
			obj.control = () => this.Contact_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * terms_bid \
		 * ```
		 */
		terms_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * terms?val \
		 * ```
		 */
		@ $mol_mem
		terms(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * Terms_control $mol_textarea
		 * 	minimal_height 120
		 * 	value?val <=> terms?val
		 * ```
		 */
		@ $mol_mem
		Terms_control() {
			const obj = new this.$.$mol_textarea()
			
			obj.minimal_height = () => 120
			obj.value = (val?: any) => this.terms(val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Terms $mol_form_field
		 * 	name @ \Terms & Conditions
		 * 	bid <= terms_bid
		 * 	control <= Terms_control
		 * ```
		 */
		@ $mol_mem
		Terms() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Terms_name' )
			obj.bid = () => this.terms_bid()
			obj.control = () => this.Terms_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * date_bid \
		 * ```
		 */
		date_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * date?val \
		 * ```
		 */
		@ $mol_mem
		date(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * Date_control $aspirity_account_new_date value?val <=> date?val
		 * ```
		 */
		@ $mol_mem
		Date_control() {
			const obj = new this.$.$aspirity_account_new_date()
			
			obj.value = (val?: any) => this.date(val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Date $mol_form_field
		 * 	name @ \Date of payment
		 * 	bid <= date_bid
		 * 	control <= Date_control
		 * ```
		 */
		@ $mol_mem
		Date() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Date_name' )
			obj.bid = () => this.date_bid()
			obj.control = () => this.Date_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * invoice_bid \
		 * ```
		 */
		invoice_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * invoice?val \
		 * ```
		 */
		@ $mol_mem
		invoice(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * invoice_dict *
		 * ```
		 */
		invoice_dict() {
			return {
			}
		}
		
		/**
		 * ```tree
		 * Invoice_control $mol_select
		 * 	value?val <=> invoice?val
		 * 	dictionary <= invoice_dict
		 * ```
		 */
		@ $mol_mem
		Invoice_control() {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.invoice(val)
			obj.dictionary = () => this.invoice_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Invoice $mol_form_field
		 * 	name @ \Printed invoice form
		 * 	bid <= invoice_bid
		 * 	control <= Invoice_control
		 * ```
		 */
		@ $mol_mem
		Invoice() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Invoice_name' )
			obj.bid = () => this.invoice_bid()
			obj.control = () => this.Invoice_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * company_bid \
		 * ```
		 */
		company_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * company?val \
		 * ```
		 */
		@ $mol_mem
		company(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * company_dict *
		 * ```
		 */
		company_dict() {
			return {
			}
		}
		
		/**
		 * ```tree
		 * Company_control $mol_select
		 * 	value?val <=> company?val
		 * 	dictionary <= company_dict
		 * ```
		 */
		@ $mol_mem
		Company_control() {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.company(val)
			obj.dictionary = () => this.company_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Company $mol_form_field
		 * 	name @ \Company
		 * 	bid <= company_bid
		 * 	control <= Company_control
		 * ```
		 */
		@ $mol_mem
		Company() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Company_name' )
			obj.bid = () => this.company_bid()
			obj.control = () => this.Company_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * currency_bid \
		 * ```
		 */
		currency_bid() {
			return ""
		}
		
		/**
		 * ```tree
		 * currency?val \
		 * ```
		 */
		@ $mol_mem
		currency(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * currency_dict *
		 * ```
		 */
		currency_dict() {
			return {
			}
		}
		
		/**
		 * ```tree
		 * Currency_control $mol_select
		 * 	value?val <=> currency?val
		 * 	dictionary <= currency_dict
		 * ```
		 */
		@ $mol_mem
		Currency_control() {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.currency(val)
			obj.dictionary = () => this.currency_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Currency $mol_form_field
		 * 	name @ \Currency
		 * 	bid <= currency_bid
		 * 	control <= Currency_control
		 * ```
		 */
		@ $mol_mem
		Currency() {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Currency_name' )
			obj.bid = () => this.currency_bid()
			obj.control = () => this.Currency_control()
			
			return obj
		}
		
		/**
		 * ```tree
		 * rows /
		 * ```
		 */
		rows() {
			return [
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Table $mol_list rows <= rows
		 * ```
		 */
		@ $mol_mem
		Table() {
			const obj = new this.$.$mol_list()
			
			obj.rows = () => this.rows()
			
			return obj
		}
		
		/**
		 * ```tree
		 * table_content / <= Table
		 * ```
		 */
		table_content() {
			return [
				this.Table()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Table_content $mol_view sub <= table_content
		 * ```
		 */
		@ $mol_mem
		Table_content() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => this.table_content()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Table_field $mol_form_field
		 * 	label /
		 * 	Content <= Table_content
		 * ```
		 */
		@ $mol_mem
		Table_field() {
			const obj = new this.$.$mol_form_field()
			
			obj.label = () => [
			] as readonly any[]
			obj.Content = () => this.Table_content()
			
			return obj
		}
		
		/**
		 * ```tree
		 * row_add?val null
		 * ```
		 */
		@ $mol_mem
		row_add(val?: any) {
			if ( val !== undefined ) return val as never
			return null as any
		}
		
		/**
		 * ```tree
		 * Add $mol_button_major
		 * 	title @ \Add row
		 * 	click?val <=> row_add?val
		 * ```
		 */
		@ $mol_mem
		Add() {
			const obj = new this.$.$mol_button_major()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_new_Add_title' )
			obj.click = (val?: any) => this.row_add(val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * total \0
		 * ```
		 */
		total() {
			return "0"
		}
		
		/**
		 * ```tree
		 * Total $mol_labeler
		 * 	title @ \Total
		 * 	content / <= total
		 * ```
		 */
		@ $mol_mem
		Total() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_new_Total_title' )
			obj.content = () => [
				this.total()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * New $mol_form
		 * 	form_fields /
		 * 		<= Subject
		 * 		<= Number
		 * 		<= Status
		 * 		<= Contractor
		 * 		<= Contact
		 * 		<= Terms
		 * 		<= Date
		 * 		<= Invoice
		 * 		<= Company
		 * 		<= Currency
		 * 		<= Table_field
		 * 	buttons /
		 * 		<= Add
		 * 		<= Total
		 * ```
		 */
		@ $mol_mem
		New() {
			const obj = new this.$.$mol_form()
			
			obj.form_fields = () => [
				this.Subject(),
				this.Number(),
				this.Status(),
				this.Contractor(),
				this.Contact(),
				this.Terms(),
				this.Date(),
				this.Invoice(),
				this.Company(),
				this.Currency(),
				this.Table_field()
			] as readonly any[]
			obj.buttons = () => [
				this.Add(),
				this.Total()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * List $mol_list rows / <= New
		 * ```
		 */
		@ $mol_mem
		List() {
			const obj = new this.$.$mol_list()
			
			obj.rows = () => [
				this.New()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * people_bid!id \
		 * ```
		 */
		people_bid(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * people!id?val \
		 * ```
		 */
		@ $mol_mem_key
		people(id: any, val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * People_control!id $mol_select value?val <=> people!id?val
		 * ```
		 */
		@ $mol_mem_key
		People_control(id: any) {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.people(id, val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * People!id $mol_form_field
		 * 	name @ \People
		 * 	bid <= people_bid!id
		 * 	control <= People_control!id
		 * ```
		 */
		@ $mol_mem_key
		People(id: any) {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_People_name' )
			obj.bid = () => this.people_bid(id)
			obj.control = () => this.People_control(id)
			
			return obj
		}
		
		/**
		 * ```tree
		 * position_bid!id \
		 * ```
		 */
		position_bid(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * position!id?val \
		 * ```
		 */
		@ $mol_mem_key
		position(id: any, val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * Position_control!id $mol_select value?val <=> position!id?val
		 * ```
		 */
		@ $mol_mem_key
		Position_control(id: any) {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.position(id, val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Position!id $mol_form_field
		 * 	name @ \Position
		 * 	bid <= position_bid!id
		 * 	control <= Position_control!id
		 * ```
		 */
		@ $mol_mem_key
		Position(id: any) {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Position_name' )
			obj.bid = () => this.position_bid(id)
			obj.control = () => this.Position_control(id)
			
			return obj
		}
		
		/**
		 * ```tree
		 * rate_bid!id \
		 * ```
		 */
		rate_bid(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * rate!id?val \0
		 * ```
		 */
		@ $mol_mem_key
		rate(id: any, val?: any) {
			if ( val !== undefined ) return val as never
			return "0"
		}
		
		/**
		 * ```tree
		 * Rate_control!id $mol_string value?val <=> rate!id?val
		 * ```
		 */
		@ $mol_mem_key
		Rate_control(id: any) {
			const obj = new this.$.$mol_string()
			
			obj.value = (val?: any) => this.rate(id, val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Rate!id $mol_form_field
		 * 	name @ \Rate
		 * 	bid <= rate_bid!id
		 * 	control <= Rate_control!id
		 * ```
		 */
		@ $mol_mem_key
		Rate(id: any) {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Rate_name' )
			obj.bid = () => this.rate_bid(id)
			obj.control = () => this.Rate_control(id)
			
			return obj
		}
		
		/**
		 * ```tree
		 * time_bid!id \
		 * ```
		 */
		time_bid(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * time!id?val \0
		 * ```
		 */
		@ $mol_mem_key
		time(id: any, val?: any) {
			if ( val !== undefined ) return val as never
			return "0"
		}
		
		/**
		 * ```tree
		 * Time_control!id $mol_string value?val <=> time!id?val
		 * ```
		 */
		@ $mol_mem_key
		Time_control(id: any) {
			const obj = new this.$.$mol_string()
			
			obj.value = (val?: any) => this.time(id, val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Time!id $mol_form_field
		 * 	name @ \Hours
		 * 	bid <= time_bid!id
		 * 	control <= Time_control!id
		 * ```
		 */
		@ $mol_mem_key
		Time(id: any) {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Time_name' )
			obj.bid = () => this.time_bid(id)
			obj.control = () => this.Time_control(id)
			
			return obj
		}
		
		/**
		 * ```tree
		 * price!id \0
		 * ```
		 */
		price(id: any) {
			return "0"
		}
		
		/**
		 * ```tree
		 * Price_content!id $mol_view sub / <= price!id
		 * ```
		 */
		@ $mol_mem_key
		Price_content(id: any) {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => [
				this.price(id)
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Price!id $mol_form_field
		 * 	name @ \Price
		 * 	Content <= Price_content!id
		 * ```
		 */
		@ $mol_mem_key
		Price(id: any) {
			const obj = new this.$.$mol_form_field()
			
			obj.name = () => this.$.$mol_locale.text( '$aspirity_account_new_Price_name' )
			obj.Content = () => this.Price_content(id)
			
			return obj
		}
	}
	
	export class $aspirity_account_new_date extends $mol_date {
		
		/**
		 * ```tree
		 * hint \YYYY-MM-DD
		 * ```
		 */
		hint() {
			return "YYYY-MM-DD"
		}
	}
	
}

